import { Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useAuth } from '@context/AuthContext'
import './ModuleRoute.css'

/**
 * ModuleRoute — Wrapper de rutas que verifica:
 * 1. Que el usuario esté autenticado (redirige a /login si no)
 * 2. Que el usuario tenga el módulo habilitado (muestra pantalla de acceso denegado si no)
 *
 * SuperAdmins siempre tienen acceso a todos los módulos.
 *
 * @param {string} moduleKey — Clave del módulo (ej: 'conciliacion_bancaria')
 * @param {React.ReactNode} children — Componente a renderizar si tiene acceso
 */
function ModuleRoute({ moduleKey, children }) {
    const { isAuthenticated, isLoading, modulesLoaded, hasModule, userEmpresa, refreshUserModules } = useAuth()

    useEffect(() => {
        if (isAuthenticated) refreshUserModules()
    }, [isAuthenticated, refreshUserModules])

    if (isLoading || !modulesLoaded) {
        return (
            <div className="module-route-loading">
                <div className="module-route-spinner"></div>
                <p>Verificando permisos...</p>
            </div>
        )
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />
    }

    if (!hasModule(moduleKey)) {
        return (
            <div className="module-route-denied">
                <div className="module-denied-card">
                    <div className="module-denied-icon">🔒</div>
                    <h2>Acceso restringido</h2>
                    <p>
                        Este módulo no está habilitado para tu cuenta
                        {userEmpresa !== 'Sin empresa' && ` (${userEmpresa})`}.
                    </p>
                    <p className="module-denied-sub">
                        Contacta a tu administrador para solicitar acceso.
                    </p>
                    <a href="/dashboard" className="module-denied-btn">
                        Volver al Dashboard
                    </a>
                </div>
            </div>
        )
    }

    return children
}

export default ModuleRoute
